import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { MaintenanceGuard, MaintenanceOverGuard, QuickscanComponent } from "@kpx/quickscan";
import { SessionPermission } from "../../types/session-permission";
import { AuthenticationFailedComponent } from "../components/screens/error/authentication-failed/authentication-failed.component";
import { ServicesUnavailableComponent } from "../components/screens/error/services-unavailable/services-unavailable.component";
import { MaintenanceComponent } from "../components/screens/maintenance/maintenance.component";
import { PowerbiComponent } from "../components/screens/powerbi/powerbi.component";
import { QuickscansComponent } from "../components/screens/quickscans/quickscans.component";
import { SuccessComponent } from "../components/screens/success/success.component";
import { SessionService } from "../services/session.service";

export const ROUTES: Routes = [
  {
    path: "",
    canActivate: [MsalGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "no-access",
      },
      {
        path: "quickscan",
        component: QuickscanComponent,
        canActivate: [(): boolean => inject(SessionService).hasPermission(SessionPermission.VIEW_QUICKSCAN), MaintenanceGuard],
      },
      {
        path: "powerbi",
        component: PowerbiComponent,
        canActivate: [(): boolean => inject(SessionService).hasPermission(SessionPermission.POWERBI_REPORT)],
      },
      {
        path: "quickscans",
        component: QuickscansComponent,
        canActivate: [(): boolean => inject(SessionService).hasPermission(SessionPermission.VIEW_QUICKSCANS), MaintenanceGuard],
      },
      {
        path: "success",
        component: SuccessComponent,
        canActivate: [(): boolean => inject(SessionService).hasPermission(SessionPermission.VIEW_SUCCESS), MaintenanceGuard],
      },
      {
        path: "maintenance",
        canActivate: [MaintenanceOverGuard],
        component: MaintenanceComponent,
      },
      {
        path: "error",
        children: [
          {
            path: "authentication-failed",
            component: AuthenticationFailedComponent,
          },
          {
            path: "services-unavailable",
            component: ServicesUnavailableComponent,
          },
        ],
      },
    ],
  },
  { path: "**", redirectTo: "quickscan" },
];
